(function() {
	"use strict"
	angular.module( "ATMGurus")
	.provider( "Navigation",
	function() {
		
		this.$get = [
			"ApiQuery",
			"$http",
			"$q",
			"$location",
			"$stateParams",
			"$state",
			"$rootScope",
			"$timeout",
			function( ApiQuery, $http, $q, $location, $stateParams, $state, $rootScope, $timeout ) {
				
				var
				currentMainView = $location.path().substr( 1 ),
				currentSubView = undefined,
				menusMap = [],
				subNav = undefined,
				menus = undefined,
				_this = this,
				currentPage = undefined,
				defer = $q.defer(),
				fetchInProgress = false,
				activeNavMenu = undefined;
				
				/**
				*
				*	Fetch
				*	fetches navigation hierarcy
				*
				*	@param forceReload -> true forces navigation reload
				*/
				function fetchMenus(forceReload) {
					return new Promise((resolve, reject) => {
						if (!menus || forceReload) {
							fetchInProgress = true;
							return ApiQuery('menus', '', 'GET')
								.then(response => {
									fetchInProgress = false
									menus = response.data
									resolve(menus)
								})
								.catch(reason => reject(reason))
						}
						else {
							resolve(menus);
						}
					})
				}
				
				/**
				*
				*	fetchMenu
				*
				*	used from fetchNavMenu directive
				*	and., more in general to fetch a single menu
				*
				*/
				function fetchMenu( name ) {
					
					var defer = $q.defer();
					
					if ( menus && angular.isDefined( menus[name] ) ) {
						activeNavMenu = menus[name];
						defer.resolve (menus[name]);
					}
					else {
						fetchMenus()
						.then(response => {
							if (response && response[name]) {
								activeNavMenu = menus[name]
								defer.resolve(response[name])
							} else {
								return false
							}
						})
						.catch(reason => defer.reject(reason))
					}
					return defer.promise;
				}
				
				/**
				*
				* onStateChange populate cuurent page informations
				*
				*
				*/
				$rootScope.$on( "$stateChangeStart", function( event, toState, toParams, fromState, fromParams ) {
					
					var item;
					
					if ( !_.isUndefined ( toParams.page ) ) {
						currentMainView = toParams.page.split( "/" )[0];
						item = toParams.page;
					}
					else {
						currentMainView = item = toState.name
					}
					
					var exploded = $location.path().split( "/" );
					currentPage = exploded[ exploded.length - 1 ];
					
				})
				
				return {
					
					menus: function() {
						return menus
					},
					
					fetchMenu: fetchMenu,
					
					// menusMap: menusMap,
					subnav: undefined,
					activeNavMenu: activeNavMenu,
					fetchMenus: fetchMenus,
					
					isActive: function( viewLocation ) {
						if ( currentMainView === 'store.repairs' && /services$/.test(viewLocation) ) {
							return true
						}
						else if ( /products/.test(currentMainView) && /product/.test( viewLocation ) ) {
							return true;
						}
						return viewLocation ===  '/' + currentMainView ;
					},
					
					isActiveSub: function( sub ) {
						return sub === $location.path()
					},
					
					getCurrentPageTitle: function() {
						
						if ( angular.isDefined( activeNavMenu ) ) {
							var title = undefined;
							activeNavMenu.map( function( item ) {
								if ( item.url === $location.path() ) {
									title = item.title
								}
							})
							return title;
						}
					},
					
					getCurrentPageTitlePromise: function() {
						
						var defer = $q.defer()
						
						$timeout( function() {
							if ( angular.isDefined( activeNavMenu ) ) {
								var title = undefined;
								activeNavMenu.map( function( item ) {
									if ( item.url === $location.path() ) {
										title = item.title
									}
								})
								defer.resolve( title )
							}
						}, 200 )
						
						
						return defer.promise
					},
					
					// ugly name convention
					// this returns the current MAIN page (Main section)
					getActive: function() {
						return currentMainView;
					},
					
					getCurrentPage: function() {
						return currentPage
					},
					
					getSubnav: function() {
						return subNav;
					}
				}
			}]
		}
	);
	
})()


// WEBPACK FOOTER //
// ./src/app/providers/Navigation.js